import * as tslib_1 from "tslib";
import { BaseAPI } from '@app/core/class/baseAPI.class';
import { HttpClient } from '@angular/common/http';
var MemberService = /** @class */ (function (_super) {
    tslib_1.__extends(MemberService, _super);
    function MemberService(httpClient) {
        var _this = _super.call(this, httpClient) || this;
        _this.httpClient = httpClient;
        _this.endpoint = '/mock/members.json';
        _this.apiFieldsMap = {};
        _this.fieldsRequired = [];
        return _this;
    }
    return MemberService;
}(BaseAPI));
export { MemberService };
